import React, { useEffect } from 'react';
import Dashboard from './Dashboard';
import LandingPage from './LandingPage';
import { getHasShowTextVisitPage } from 'utils/localstore';


const TextVisitPage = () => {
    const [showDashboard, setShowDashboard] = React.useState(false);

    useEffect(() => {
        const hasShowTextVisitPage = getHasShowTextVisitPage();
        if (hasShowTextVisitPage) {
            setShowDashboard(true);
        }
    }, []);

    if (showDashboard) {
        return (
            <Dashboard />
        );
    }

    return (
        <LandingPage onGetStarted={() => setShowDashboard(true)} />
    );
};

export default TextVisitPage;
